export const CONFIG = 'config';
export const DATA = 'data';
export const AXES = 'axes';
export const LAYERDEFS = 'layerDef';
export const WIDTH = 'width';
export const HEIGHT = 'height';
export const MOUNT = 'mount';
export const TRANSFORM = 'transform';
export const TRANSFORMEDDATA = 'transformedData';
export const DATADOMAIN = 'dataDomain';
export const FIELDS = 'fields';
export const LAYERAXISINDEX = 'layerAxisIndex';
export const LAYERS = 'layers';
export const DOMAIN = 'domain';

